var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright"},[_vm._v("\n      ©\n      "+_vm._s(new Date().getFullYear())+" Space oddity Inc. All Rights Reserved.\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }